import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PrivacyService } from '../privacy.service';

@Component({
  selector: 'app-privacy-banner',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div *ngIf="showBanner" class="privacy-banner">
      <div class="privacy-content">
        <h3>Vos préférences de confidentialité</h3>
        <p>Nous utilisons des cookies et des technologies similaires pour améliorer votre expérience sur notre site.</p>
        
        <div class="preferences">
          <div class="preference-item">
            <label>
              <input type="checkbox" [(ngModel)]="preferences.necessary" disabled>
              Nécessaires (toujours actifs)
            </label>
            <p class="description">Cookies essentiels au fonctionnement du site</p>
          </div>

          <div class="preference-item">
            <label>
              <input type="checkbox" [(ngModel)]="preferences.preferences">
              Préférences
            </label>
            <p class="description">Pour mémoriser vos paramètres</p>
          </div>

          <div class="preference-item">
            <label>
              <input type="checkbox" [(ngModel)]="preferences.analytics">
              Analytics
            </label>
            <p class="description">Pour améliorer nos services</p>
          </div>

          <div class="preference-item">
            <label>
              <input type="checkbox" [(ngModel)]="preferences.marketing">
              Marketing
            </label>
            <p class="description">Pour personnaliser votre expérience</p>
          </div>
        </div>

        <div class="actions">
          <button (click)="acceptAll()" class="btn btn-primary">Tout accepter</button>
          <button (click)="savePreferences()" class="btn btn-secondary">Enregistrer mes choix</button>
          <button (click)="rejectAll()" class="btn btn-outline">Tout refuser</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .privacy-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: white;
      box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
      z-index: 1000;
      padding: 1rem;
    }

    .privacy-content {
      max-width: 1200px;
      margin: 0 auto;
      padding: 1rem;
    }

    .preferences {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1rem;
      margin: 1rem 0;
    }

    .preference-item {
      padding: 0.5rem;
    }

    .description {
      font-size: 0.9rem;
      color: #666;
      margin-top: 0.25rem;
    }

    .actions {
      display: flex;
      gap: 1rem;
      justify-content: flex-end;
      margin-top: 1rem;
    }

    .btn {
      padding: 0.5rem 1rem;
      border-radius: 4px;
      cursor: pointer;
      border: none;
    }

    .btn-primary {
      background: #007bff;
      color: white;
    }

    .btn-secondary {
      background: #6c757d;
      color: white;
    }

    .btn-outline {
      background: transparent;
      border: 1px solid #6c757d;
      color: #6c757d;
    }
  `]
})
export class PrivacyBannerComponent implements OnInit {
  showBanner = false;
  preferences = {
    necessary: true,
    preferences: false,
    analytics: false,
    marketing: false
  };

  constructor(private privacyService: PrivacyService) {}

  ngOnInit() {
    this.privacyService.getPreferences().subscribe(prefs => {
      this.preferences = { ...prefs };
      // Afficher la bannière uniquement si elle n'a pas encore été montrée
      this.showBanner = this.privacyService.shouldShowBanner();
    });
  }

  acceptAll() {
    this.preferences = {
      necessary: true,
      preferences: true,
      analytics: true,
      marketing: true
    };
    this.savePreferences();
  }

  rejectAll() {
    this.preferences = {
      necessary: true,
      preferences: false,
      analytics: false,
      marketing: false
    };
    this.savePreferences();
  }

  savePreferences() {
    this.privacyService.updatePreferences(this.preferences);
    this.showBanner = false;
  }
} 